import { render, staticRenderFns } from "./GeneralStatsBox.vue?vue&type=template&id=7690e146&scoped=true&"
import script from "./GeneralStatsBox.vue?vue&type=script&lang=js&"
export * from "./GeneralStatsBox.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStatsBox.vue?vue&type=style&index=0&id=7690e146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7690e146",
  null
  
)

export default component.exports